/* eslint-disable max-len */
export const infoIcon = `M6.063.563a5.5,5.5,0,1,0,5.5,5.5A5.5,5.5,0,0,0,6.063.563Zm0,2.44a.931.931,0,1,1-.931.931A.931.931,0,0,1,6.063,3ZM7.3,8.635a.266.266,0,0,1-.266.266H5.087a.266.266,0,0,1-.266-.266V8.1a.266.266,0,0,1,.266-.266h.266V6.417H5.087a.266.266,0,0,1-.266-.266V5.619a.266.266,0,0,1,.266-.266H6.506a.266.266,0,0,1,.266.266V7.837h.266A.266.266,0,0,1,7.3,8.1Z`;
export const settingsIcon = `M13.108,9.039a3.69,3.69,0,0,0,0-1.078L14.3,7.053a.272.272,0,0,0,.068-.352L13.238,4.8a.288.288,0,0,0-.345-.121l-1.408.55a4.16,4.16,0,0,0-.956-.539l-.215-1.458A.273.273,0,0,0,10.038,3H7.776a.273.273,0,0,0-.277.231L7.284,4.688a4.375,4.375,0,0,0-.956.539l-1.408-.55a.279.279,0,0,0-.345.121L3.445,6.7a.266.266,0,0,0,.068.352l1.193.907a3.69,3.69,0,0,0,0,1.078l-1.193.908a.272.272,0,0,0-.068.352l1.131,1.9a.288.288,0,0,0,.345.121l1.408-.55a4.16,4.16,0,0,0,.956.539L7.5,13.769A.273.273,0,0,0,7.776,14h2.262a.273.273,0,0,0,.277-.231l.215-1.458a4.375,4.375,0,0,0,.956-.539l1.408.55a.279.279,0,0,0,.345-.121l1.131-1.9a.272.272,0,0,0-.068-.352l-1.193-.908Zm-4.2,1.386A1.926,1.926,0,1,1,10.886,8.5,1.955,1.955,0,0,1,8.907,10.425Z`;
export const coinsIcon = `M0,8.708v.917C0,10.383,1.848,11,4.125,11S8.25,10.383,8.25,9.625V8.708a7.813,7.813,0,0,1-4.125.917A7.813,7.813,0,0,1,0,8.708ZM6.875,2.75C9.152,2.75,11,2.133,11,1.375S9.152,0,6.875,0,2.75.617,2.75,1.375,4.6,2.75,6.875,2.75ZM0,6.454V7.563c0,.758,1.848,1.375,4.125,1.375S8.25,8.321,8.25,7.563V6.454A6.919,6.919,0,0,1,4.125,7.563,6.919,6.919,0,0,1,0,6.454Zm8.938.236C10.169,6.452,11,6.009,11,5.5V4.583a5.276,5.276,0,0,1-2.062.741ZM4.125,3.438C1.848,3.438,0,4.207,0,5.156S1.848,6.875,4.125,6.875,8.25,6.106,8.25,5.156,6.4,3.438,4.125,3.438Zm4.712,1.21C10.126,4.415,11,3.96,11,3.438V2.52a6.994,6.994,0,0,1-3.453.9A2.406,2.406,0,0,1,8.837,4.647Z`;
export const separator01 = `M739.467 66.4001C729.84 66.4001 722.013 58.7468 722.013 49.3335C722.013 39.9335 729.84 32.2668 739.467 32.2668C749.08 32.2668 756.907 39.9335 756.907 49.3335C756.907 58.7468 749.08 66.4001 739.467 66.4001ZM312.213 49.4668C312.213 58.8801 304.387 66.5335 294.76 66.5335C285.147 66.5335 277.32 58.8801 277.32 49.4668C277.32 40.0535 285.147 32.4001 294.76 32.4001C304.387 32.4001 312.213 40.0535 312.213 49.4668ZM406.72 87.9467L384.307 88.1202L384.333 64.5069H351.493L351.4 87.9335L10.1599 89.0668V10.4267H32.8667L32.48 33.3202L65.9599 33.6535L66.1068 10.1868H406.72V45.1202L321.227 45.2535C319.173 32.6802 308.093 23.0402 294.76 23.0402C279.987 23.0402 267.96 34.8935 267.96 49.4668C267.96 64.0401 279.987 75.8934 294.76 75.8934C307.76 75.8934 318.627 66.7334 321.053 54.6134L406.72 54.4801V87.9467ZM739.467 22.9069C726.307 22.9069 715.333 32.3068 713.08 44.6535L416.08 45.1069V0.826691H56.8L56.6534 24.1868L42 24.0535L42.3868 1.0668H0.800049V98.4668L360.733 97.2668L360.827 73.8668H374.96L374.933 97.5467L416.08 97.2402V54.4668L713.08 54.0134C715.333 66.3601 726.307 75.76 739.467 75.76C754.24 75.76 766.267 63.9068 766.267 49.3335C766.267 34.7601 754.24 22.9069 739.467 22.9069Z`;
export const emailIcon = `M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z`;
export const twitterIcon = `M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z`;
export const linkedinIcon = `M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z`;
export const telegramIcon = `M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z`;
export const githubIcon = `M48.854 0C21.839 0 0 22 0 49.217c0 21.756 13.993 40.172 33.405 46.69 2.427.49 3.316-1.059 3.316-2.362 0-1.141-.08-5.052-.08-9.127-13.59 2.934-16.42-5.867-16.42-5.867-2.184-5.704-5.42-7.17-5.42-7.17-4.448-3.015.324-3.015.324-3.015 4.934.326 7.523 5.052 7.523 5.052 4.367 7.496 11.404 5.378 14.235 4.074.404-3.178 1.699-5.378 3.074-6.6-10.839-1.141-22.243-5.378-22.243-24.283 0-5.378 1.94-9.778 5.014-13.2-.485-1.222-2.184-6.275.486-13.038 0 0 4.125-1.304 13.426 5.052a46.97 46.97 0 0 1 12.214-1.63c4.125 0 8.33.571 12.213 1.63 9.302-6.356 13.427-5.052 13.427-5.052 2.67 6.763.97 11.816.485 13.038 3.155 3.422 5.015 7.822 5.015 13.2 0 18.905-11.404 23.06-22.324 24.283 1.78 1.548 3.316 4.481 3.316 9.126 0 6.6-.08 11.897-.08 13.526 0 1.304.89 2.853 3.316 2.364 19.412-6.52 33.405-24.935 33.405-46.691C97.707 22 75.788 0 48.854 0z`;
export const gitlabIcon = `M 191.829987 74.729996 L 191.559998 74.039993 L 165.420013 5.820007 C 164.888168 4.48291 163.946457 3.348663 162.729996 2.580017 C 160.236816 1.032288 157.042923 1.203979 154.729996 3.01001 C 153.613327 3.917053 152.803238 5.146149 152.410004 6.529999 L 134.759995 60.529999 L 63.289993 60.529999 L 45.639999 6.529999 C 45.257202 5.138611 44.445374 3.903351 43.320007 3 C 41.00708 1.19397 37.813187 1.022308 35.32 2.570007 C 34.10627 3.341797 33.16539 4.475037 32.629997 5.809998 L 6.440002 74 L 6.18 74.690002 C -1.550491 94.888535 5.014748 117.764923 22.279999 130.789993 L 22.370003 130.860001 L 22.610001 131.029999 L 62.429993 160.850006 L 82.130005 175.76001 L 94.130005 184.820007 C 97.014694 187.010223 101.005295 187.010223 103.889999 184.820007 L 115.889999 175.76001 L 135.589996 160.850006 L 175.649994 130.850006 L 175.75 130.770004 C 192.974884 117.743759 199.527496 94.90741 191.829987 74.729996 Z`;
export const lightbulbIcon = `M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z`; //384 512
export const spaceshipIcon = `M371.873,315.686c2.521-29.395,3.85-55.362,3.997-77.896c-0.142-49.97-7.638-92.951-22.467-128.917c-14.841-35.974-39.683-71.384-74.542-106.243c-1.817-1.818-4.094-2.693-6.823-2.625c-2.729,0.073-5.073,1.089-7.032,3.047c-36.53,36.537-61.726,71.671-75.594,105.399c-13.855,33.74-20.851,76.855-20.992,129.34c0.141,22.546,1.475,48.507,3.99,77.896c-99.731,0-43.88,220.252-43.88,220.252c1.126,4.486,4.205,6.867,9.241,7.143h26.873c2.521,0,4.755-0.979,6.713-2.944c0.839-0.838,1.402-1.536,1.683-2.093l40.104-75.796l117.993-0.007l40.104,75.803c1.817,3.219,4.614,4.896,8.396,5.037l26.879,0.006c2.791-0.281,5.037-1.261,6.714-2.943c1.261-1.262,2.099-2.656,2.521-4.199C415.76,535.943,468.551,315.686,371.873,315.686z M292.295,309.559c-5.6,5.601-12.313,8.409-20.146,8.403c-7.84,0-14.554-2.797-20.159-8.403c-5.606-5.605-8.403-12.319-8.403-20.159c-0.006-7.84,2.797-14.559,8.396-20.159c5.601-5.594,12.32-8.396,20.159-8.396c7.84,0,14.554,2.797,20.159,8.403c5.601,5.6,8.397,12.32,8.403,20.16C300.698,297.252,297.889,303.959,292.295,309.559z M292.295,229.999c-5.6,5.6-12.313,8.409-20.146,8.403c-7.84,0-14.554-2.797-20.159-8.403c-5.606-5.606-8.403-12.32-8.403-20.159c-0.006-7.84,2.797-14.56,8.396-20.159c5.601-5.594,12.32-8.397,20.159-8.397c7.84,0,14.554,2.797,20.159,8.403c5.601,5.6,8.397,12.319,8.403,20.159C300.698,217.691,297.889,224.399,292.295,229.999z M292.295,150.439c-5.6,5.6-12.313,8.409-20.146,8.403c-7.84,0-14.554-2.797-20.159-8.403c-5.606-5.606-8.403-12.32-8.403-20.159c-0.006-7.84,2.797-14.56,8.396-20.16c5.601-5.593,12.32-8.396,20.159-8.396c7.84,0,14.554,2.797,20.159,8.403c5.601,5.6,8.397,12.32,8.403,20.159C300.698,138.132,297.889,144.839,292.295,150.439z`; // 543 543
export const contactIcon = `M105.4,221c0,9.391-7.609,17-17,17h-34c-9.391,0-17-7.609-17-17l0,0c0-9.391,7.609-17,17-17h34C97.792,204,105.4,211.609,105.4,221L105.4,221z M105.4,112.2c0-9.391-7.609-17-17-17h-34c-9.391,0-17,7.609-17,17l0,0c0,9.391,7.609,17,17,17h34C97.792,129.2,105.4,121.591,105.4,112.2L105.4,112.2z M105.4,329.801c0-9.393-7.609-17-17-17h-34c-9.391,0-17,7.607-17,17l0,0c0,9.391,7.609,17,17,17h34C97.792,346.801,105.4,339.191,105.4,329.801L105.4,329.801z M404.6,54.4v333.2c0,30.043-24.357,54.4-54.398,54.4h-238c-30.042,0-54.4-24.357-54.4-54.4V360.4h30.6c16.871,0,30.6-13.73,30.6-30.6c0-16.871-13.729-30.602-30.6-30.602H57.8v-47.6h30.6c16.871,0,30.6-13.729,30.6-30.6s-13.729-30.6-30.6-30.6H57.8v-47.6h30.6c16.871,0,30.6-13.729,30.6-30.6c0-16.871-13.729-30.6-30.6-30.6H57.8V54.4c0-30.042,24.358-54.4,54.4-54.4h238C380.242,0,404.6,24.357,404.6,54.4z M188.945,161.255c0,28.968,23.487,52.455,52.455,52.455c28.969,0,52.455-23.487,52.455-52.455c0-28.968-23.486-52.456-52.455-52.456C212.433,108.8,188.945,132.287,188.945,161.255z M323,289.482c0-32.184-26.098-58.283-58.283-58.283H218.09c-32.191,0-58.29,26.1-58.29,58.283v23.318H323V289.482z`; // 442 442
export const ethIcon = `M127.9611 0 125.1661 9.5 125.1661 285.168 127.9611 287.958 255.9231 212.32zM127.962 0 0 212.32 127.962 287.959 127.962 154.158zM127.9611 312.1866 126.3861 314.1066 126.3861 412.3056 127.9611 416.9066 255.9991 236.5866zM127.962 416.9052 127.962 312.1852 0 236.5852zMM127.9611 287.9577 255.9211 212.3207 127.9611 154.1587zM0.0009 212.3208 127.9609 287.9578 127.9609 154.1588z`; // 256 417
export const calendarIcon = `M112 368h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V160h352v298z`; // 448 512
export const globeIcon = `M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm193.2 152h-82.5c-9-44.4-24.1-82.2-43.2-109.1 55 18.2 100.2 57.9 125.7 109.1zM336 256c0 22.9-1.6 44.2-4.3 64H164.3c-2.7-19.8-4.3-41.1-4.3-64s1.6-44.2 4.3-64h167.4c2.7 19.8 4.3 41.1 4.3 64zM248 40c26.9 0 61.4 44.1 78.1 120H169.9C186.6 84.1 221.1 40 248 40zm-67.5 10.9c-19 26.8-34.2 64.6-43.2 109.1H54.8c25.5-51.2 70.7-90.9 125.7-109.1zM32 256c0-22.3 3.4-43.8 9.7-64h90.5c-2.6 20.5-4.2 41.8-4.2 64s1.5 43.5 4.2 64H41.7c-6.3-20.2-9.7-41.7-9.7-64zm22.8 96h82.5c9 44.4 24.1 82.2 43.2 109.1-55-18.2-100.2-57.9-125.7-109.1zM248 472c-26.9 0-61.4-44.1-78.1-120h156.2c-16.7 75.9-51.2 120-78.1 120zm67.5-10.9c19-26.8 34.2-64.6 43.2-109.1h82.5c-25.5 51.2-70.7 90.9-125.7 109.1zM363.8 320c2.6-20.5 4.2-41.8 4.2-64s-1.5-43.5-4.2-64h90.5c6.3 20.2 9.7 41.7 9.7 64s-3.4 43.8-9.7 64h-90.5z`; // 496 512
export const unlockIcon = `M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z`; // 448 512
// Traveling retraction wave for the page-switch pulse: piece `order` (0 =
// rightmost, it leads) runs its own retract-and-return sub-pulse inside the
// global phase (0..1), so the bar-end fins dip in a right-to-left wave.
// waveWindow returns the piece's local sub-pulse progress (0 before it
// fires, 1 once it has settled); orders may be fractional to slot pieces
// between the named ones.
const waveWindow = (phase: number, order: number, count: number): number => {
  const span = 0.55;
  const start = (order * (1 - span)) / Math.max(1, count - 1);
  return Math.max(0, Math.min(1, (phase - start) / span));
};

// Remaining height fraction for a retracting piece (1 = fully out, 0 =
// fully retracted at the sub-pulse midpoint).
const waveRetract = (phase: number, order: number, count: number): number =>
  1 - Math.sin(Math.PI * waveWindow(phase, order, count));

// The title band's page-switch wipe. Unlike the other plates' single
// retract-and-return sub-pulse (waveRetract), every band piece collapses
// horizontally into its own fixed left edge, and its vanish and return
// slots are decoupled so the band reads as ONE strip: on the way out the
// pieces fire right-to-left (the strip recedes toward the corner), around
// mid-pulse the whole band sits fully invisible, and on the way home they
// fire left-to-right (the strip re-extends from the long body out to the
// arm). pos is the piece's left-to-right index (0 = the long blade,
// 1-2 its cut fins, 3 the thin rule, 4-5 the end-cap fins). Slots are
// 0.14 long, staggered 0.044 apart, cosine-eased at both ends: the out
// run spans [0, 0.36] — the blade, the only band piece carrying marks
// and bolt heads, holds still until 0.22, the instant mainFrameMarkFade
// bottoms out and long after its heads popped by ~0.11 — the void holds
// over [0.36, 0.5], and the return spans [0.5, 0.86], the blade whole
// again at 0.64, well before marks refade at 0.78 and heads reseat at
// 0.877+. Returns the piece's remaining width fraction (1 = fully out).
const bandWipe = (phase: number, pos: number): number => {
  const pieces = 6;
  const slot = 0.14;
  const step = 0.044;
  const outStart = (pieces - 1 - pos) * step;
  const inStart = 0.5 + pos * step;
  if (phase <= outStart) return 1;
  if (phase < outStart + slot)
    return 0.5 + 0.5 * Math.cos((Math.PI * (phase - outStart)) / slot);
  if (phase <= inStart) return 0;
  if (phase < inStart + slot)
    return 0.5 - 0.5 * Math.cos((Math.PI * (phase - inStart)) / slot);
  return 1;
};

// Bolt-head scale for the page-switch pulse, deliberately decoupled from
// the plates' wave windows: every head pops out during a short staggered
// slot at the very start of the pulse and pops back in during one at the
// very end, so the heads are always the first pieces to vanish and the
// last to return — a head never hovers over empty background while the
// plate it sits on is retracted. rank (0..1, the bolt's position in the
// right-to-left run) only staggers the slots: pop-out spans
// [rank * 0.06, +0.08] (all heads gone by 0.14, well before the top bar —
// the only moving plate that carries heads — starts at 0.3375), pop-in
// spans [0.86 + rank * 0.05, +0.09] (bar heads rank >= 0.7, so theirs
// starts at 0.895+, after the bar has fully regrown at 0.8875; the last
// head lands exactly at phase 1). Pop-out accelerates to nothing
// (1 - t^2); pop-in snaps back with a small easeOutBack overshoot (~10%).
// Never returns a negative scale.
const boltPlop = (phase: number, rank: number): number => {
  const outStart = rank * 0.06;
  const inStart = 0.86 + rank * 0.05;
  if (phase <= outStart || phase >= inStart + 0.09) return 1;
  if (phase < outStart + 0.08) {
    const t = (phase - outStart) / 0.08;
    return 1 - t * t;
  }
  if (phase <= inStart) return 0;
  const t = (phase - inStart) / 0.09 - 1;
  return 1 + t * t * (2.70158 * t + 1.70158);
};

// Opacity factor for the etched markings (rail vents, page pips) during
// the page-switch pulse, nested exactly inside the bolts' bracket: they
// power down starting at 0.14 — the instant the last head has popped out —
// and are fully back at 0.86, the instant the first head starts returning.
// The pulse therefore always reads bolts -> markings -> plates on the way
// out and plates -> markings -> bolts on the way home. Engravings dim
// rather than move: accelerating fade-out, easeOutQuad fade-in.
export const mainFrameMarkFade = (phase: number): number => {
  if (phase <= 0.14 || phase >= 0.86) return 1;
  if (phase < 0.22) {
    const t = (phase - 0.14) / 0.08;
    return 1 - t * t;
  }
  if (phase <= 0.78) return 0;
  const t = (phase - 0.78) / 0.08;
  return 1 - (1 - t) * (1 - t);
};

// Number of pieces in the page-switch retraction wave, in firing order:
// top fin 2 (4), fin 1 (5), the bar body (6), then the bottom fins
// rolling left to right into the tab (fractional 6.4-6.7 across the
// march, 7-8 for the closing pair). Orders 0-3 are the title band's old
// slot: the band now runs its own decoupled wipe (bandWipe) timed to
// nest exactly there, and the count stays 9 so the bar and bottom
// timing is untouched.
const WAVE_PIECES = 9;

// Shared morph math for the top bar (used by mainFrame and mainFrameFins so
// the steel bodies and their gold overlays stay welded during the pulse).
// f1/f2/fb are remaining height fractions (1 = fully out) for fin 1, fin 2
// and the bar body; y1/y2/yb the resulting bottom edges.
const finMorphGeometry = (
  thick: number,
  thin: number,
  phase: number,
): {
  f1: number;
  y1: number;
  f2: number;
  y2: number;
  fb: number;
  yb: number;
} => {
  const f1 = waveRetract(phase, 5, WAVE_PIECES);
  const f2 = waveRetract(phase, 4, WAVE_PIECES);
  const fb = waveRetract(phase, 6, WAVE_PIECES);
  return {
    f1,
    y1: thin + (thick - thin) * f1,
    f2,
    y2: thin + (thick - thin) * f2,
    fb,
    yb: thin + (thick - thin) * fb,
  };
};

// morph (0..1) is the page-switch pulse phase: the bar-end fins retract and
// re-emerge in a right-to-left wave as it runs 0 -> 1.
export const mainFrame = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): string => {
  const barEnd = w - w / 3 - 60;
  const { f1, y1, f2, y2, fb, yb } = finMorphGeometry(thick, thin, morph);
  return `M${thick + thin + corner + w / 10} ${thin}
          L${thick + thin + corner + w / 10 + thick * fb} ${yb}
          L${barEnd + thick * (1 - fb)} ${yb}
          L${barEnd + thick} ${thin}
          H${barEnd + thick * 1.5}
          L${barEnd + thick * 1.5 - thick * f1} ${y1}
          H${barEnd + thick * 3 - thick * f1}
          L${barEnd + thick * 3} ${thin}
          H${barEnd + thick * 3.5}
          L${barEnd + thick * 3.5 - thick * f2} ${y2}
          H${barEnd + thick * 5 - thick * f2}
          L${barEnd + thick * 5} ${thin}
          H${w - corner - thick - thin * 0.5}
          L${w - thick - thin} ${corner + thin * 1.5}
          V${h - corner - thick * 2.5}
          L${w - corner - thick} ${h - thick * 2.5}
          H${thick + corner + thin * 0.5} 
          L${thick + thin} ${h - corner - thick * 2.5 + thin * 0.5}
          V${corner + thin * 0.5}
          L${thick + corner + thin * 0.5} ${thin}
          H${thick + thin + corner + w / 10}
          Z
          M${w - thick} ${corner + thin + h * 0.1}
          V${corner + thin}
          L${w - corner - thick} 0
          H${thick + corner}
          L${thick} ${corner}
          V${thin + corner + h * 0.2}
          L0 ${thin + corner + h * 0.2 + thick}
          V${h - thick * 2.5 - corner - h * 0.1}
          L${thick} ${h - thick * 1.5 - corner - h * 0.1}
          V${h - thick * 2.5 - corner + thin}
          L${thick * 2 + corner - thin} ${h - thick * 1.5}
          H${thick * 2 + corner - thin + w / 4}
          L${thick * 3.5 + corner - thin + w / 4} ${h}
          H${w - (thick * 3.5 + corner - thin * 3)}
          L${w - thick + thin} ${h - thick * 2.5 - corner + thin}
          V${h - thick * 2.5 - corner - h * 0.2 + thick}
          L${w} ${h - thick * 2.5 - corner - h * 0.2}
          V${thin + corner + h * 0.1 + thick}
          L${w - thick} ${thin + corner + h * 0.1}
          Z
          ${mainFrameBottomFins(w, h, corner, thick, thin, morph).join(" ")}`;
};

// The title plate, three pieces left to right: (1) the thick underline
// blade under the title text — 3*thin tall, with two slash cuts near its
// right end echoing the top bar's cut rhythm 1:1 (0.5*thick cuts,
// 1.5*thick fins, same "/" lean, severing the full height); (2) the thin
// rule, fully detached by the same 0.5*thick gap on both sides, starting
// and ending in 45-degree tips; (3) the rising arm, sliced off the rule's
// end by a parallel gap along its own "\" slant. The arm is deliberately
// small — it rises just double the band blades' height, an end-cap for
// the band rather than a tower toward the top bar. During the page-switch
// pulse the band runs bandWipe's strip wipe: every piece collapses
// horizontally into its own fixed left edge, the strip receding
// right-to-left into the corner, sitting fully invisible mid-pulse, then
// re-extending left-to-right from the long body out to the arm.
export const mainFrameTitle = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): string => {
  const bandTop = thin + corner - thin * 2;
  // The band's end-cap: TWO identical fins at the band fins' full
  // 1.5 * thick width and the blades' own 3 * thin rise, one standard
  // 0.5 * thick gap apart — the band's fin rhythm marching out toward
  // the corner instead of ending on one tall lone blade. Rightmost of
  // the strip, they lead the wipe out (positions 5 and 4) and close it
  // coming home, each compressing into its own fixed "\" left edge, so
  // a full retraction leaves nothing behind.
  const armRise = thin * 3;
  const p2x = w - corner * 0.5 - thick;
  const a1x = p2x - thick * 1.5;
  const fa = bandWipe(morph, 5);
  const fs = bandWipe(morph, 4);
  const sRise = thin * 3;
  const s2x = a1x - thick * 0.5;
  const s5x = s2x - thick * 1.5;
  const segEnd = corner * 3.25;
  // Slash-cut geometry for the thick blade's right end: cut/fin widths
  // match the top bar's exactly; the 45-degree edges lead by the blade's
  // full 3*thin height. b1 = where the solid body's bottom edge stops.
  const cw = thick * 0.5;
  const fw = thick * 1.5;
  const lead = thin * 3;
  const b1 = segEnd - cw * 2 - fw * 2;
  const bandLeft = thick + thin * 2 + corner / 3;
  // The band's three blades open the wipe's return at positions 0-2 (the
  // long body anchors the strip: last to vanish, first back), each
  // compressing into its fixed left edge and re-extending — the
  // horizontal mirror of the top bar's fins collapsing up into their
  // thin line. f* = remaining width fractions; disjoint subpaths per
  // blade keep the cuts real gaps at any phase.
  // The body's left tip leans "/" like every other edge here, parallel to
  // the top-left corner chamfer that sits beside it.
  const fb = bandWipe(morph, 0);
  const f1 = bandWipe(morph, 1);
  const f2 = bandWipe(morph, 2);
  // The thin rule rides the wipe too (position 3) — the strip could never
  // read as one appearing/vanishing piece with its longest run pinned —
  // scaling its whole x-extent toward its left tip (the tips' 45-degree
  // lean flattens as it shrinks; at hairline height that is invisible,
  // and the scaled tips can never self-intersect).
  const fr = bandWipe(morph, 3);
  const ruleW = s5x - cw - (segEnd + cw);
  return `M${bandLeft + lead} ${corner - lead}
          L${bandLeft} ${corner}
          H${bandLeft + (b1 - bandLeft) * fb}
          L${bandLeft + (b1 - bandLeft) * fb + lead} ${corner - lead}
          Z
          M${b1 + cw} ${corner}
          H${b1 + cw + fw * f1}
          L${b1 + cw + fw * f1 + lead} ${corner - lead}
          H${b1 + cw + lead}
          Z
          M${b1 + cw * 2 + fw} ${corner}
          H${b1 + cw * 2 + fw + fw * f2}
          L${b1 + cw * 2 + fw + fw * f2 + lead} ${corner - lead}
          H${b1 + cw * 2 + fw + lead}
          Z
          M${segEnd + cw} ${corner}
          H${segEnd + cw + ruleW * fr}
          L${segEnd + cw + (ruleW - thin) * fr} ${bandTop}
          H${segEnd + cw + thin * fr}
          Z
          M${s5x} ${corner}
          H${s5x + fw * fs}
          L${s5x + fw * fs - sRise} ${corner - sRise}
          L${s5x - sRise} ${corner - sRise}
          Z
          M${a1x} ${corner}
          H${a1x + fw * fa}
          L${a1x + fw * fa - armRise} ${corner - armRise}
          L${a1x - armRise} ${corner - armRise}
          Z`;
};

// Inset carvings for the title band's two mid blades (wipe positions
// 1-2): a smaller copy of each blade's own parallelogram etched at its
// center. Unlike the static etchings (which dim via mainFrameMarkFade
// because they cannot move), each carving follows its blade's wipe
// exactly: its corners ride the blade's fixed left edge plus the
// horizontal run scaled by the remaining width, so it compresses into
// that edge welded to its plate and needs no fade. Callers paint them
// with a lighter cut of the etchings' inset contract.
export const mainFrameFinCarvings = (
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): string[] => {
  // The carving is its fin at 40% size: long edges at 30% and 70% of the
  // fixed slant rise, 0.45 * thick trimmed per side off the fin's
  // horizontal run — trims scaled by the fin's remaining width f, so the
  // carving compresses left with its metal. x0 is the fin's fixed
  // bottom-left corner, wdt its full bottom run.
  const mx = thick * 0.45;
  const rise = thin * 3;
  const carve = (x0: number, wdt: number, y0: number, f: number): string =>
    `M${x0 + mx * f + rise * 0.3} ${y0 - rise * 0.3}
          H${x0 + (wdt - mx) * f + rise * 0.3}
          L${x0 + (wdt - mx) * f + rise * 0.7} ${y0 - rise * 0.7}
          H${x0 + mx * f + rise * 0.7}
          Z`;
  const segEnd = corner * 3.25;
  const cw = thick * 0.5;
  const fw = thick * 1.5;
  const b1 = segEnd - cw * 2 - fw * 2;
  return [
    carve(b1 + cw * 2 + fw, fw, corner, bandWipe(morph, 2)),
    carve(b1 + cw, fw, corner, bandWipe(morph, 1)),
  ];
};

export const mainFrameBackground = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
): string => {
  return `M${corner + thick + thin} ${thin}
          H${w - corner - thick - thin * 0.5}
          L${w - thick - thin} ${corner + thin * 1.5}
          V${h - corner - thick * 2.5}
          L${w - corner - thick} ${h - thick * 2.5}
          H${thick + corner + thin * 0.5}
          L${thick + thin} ${h - corner - thick * 2.5 + thin * 0.5}
          V${corner + thin * 0.5}
          L${thick + corner + thin * 0.5} ${thin}
          Z`;
};

// Downward slash pieces along the bottom edge: a march of half-depth
// fins at the full 1.5 * thick width filling the rail run from its flush
// left end (the first fin's leading edge continues the corner diagonal's
// 45-degree line below the rail) up to the big bottom tab (same
// 45-degree slant as the tab's leading diagonal, all hanging from the
// bottom rail at one uniform 0.75 * thick depth). The
// page bottom is offscreen during tab switches, so it carries rhythm,
// not a show. mainFrame appends them as subpaths for their steel base;
// callers overlay the same gold dip. They close the page-switch wave
// left to right (fractional orders 6.4-6.7 across the march, then 7-8).
export const mainFrameBottomFins = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): string[] => {
  // While the frame is still measuring (all dims 0) there is no run to
  // fill — bail before the grid math divides by zero.
  if (!(thick > 0)) return [];
  const tabStart = thick * 2 + corner - thin + w / 4;
  const runStart = tabStart - w / 4;
  const yTop = h - thick * 1.5;
  // The run is one even grid: as many 1.5 * thick slots as fit a
  // ~2 * thick pitch (never fewer than one shallow fin plus the closing
  // pair), the remainder spread uniformly across every cut, so the march
  // locks flush into the corner diagonal on the left and steps into the
  // tab's leading diagonal on the right with the same cut everywhere —
  // no double gap at the closing pair.
  const slots = Math.max(3, Math.round(w / (8 * thick)));
  const pitch = w / 4 / slots;
  const shallow = slots - 2;
  const last = Math.max(1, shallow - 1);
  const pieces = [
    ...Array.from({ length: shallow }, (_, i) => ({
      x: runStart + i * pitch,
      order: 6.4 + (0.3 * i) / last,
    })),
    { x: runStart + shallow * pitch, order: 7 },
    { x: runStart + (shallow + 1) * pitch, order: 8 },
  ];
  const wd = thick * 1.5;
  // Uniform half depth across the march, closing pair included.
  const d = thick * 0.75;
  return pieces.map(({ x, order }) => {
    const dp = d * waveRetract(morph, order, WAVE_PIECES);
    return `M${x} ${yTop}
          H${x + wd}
          L${x + wd + dp} ${yTop + dp}
          H${x + dp}
          Z`;
  });
};

// The top bar's gold-dip overlay shapes: the bar body itself (the largest fin,
// chamfered at both ends, spanning the thin line's underside down to the bar
// bottom) plus the two larger steel fins between its slash cuts (1.5*thick
// wide, same slant, anchored like the cuts at w - w/3 - 60). All of them
// already exist as bar geometry inside mainFrame; this returns just their
// outlines so callers can overlay the same steel-to-gold dip used on the
// bottom cascade. morph (0..1) mirrors mainFrame's page-switch pulse so the
// overlays track the morphing steel exactly.
export const mainFrameFins = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): string[] => {
  const barEnd = w - w / 3 - 60;
  const barStart = thick + thin + corner + w / 10;
  const { f1, y1, f2, y2, fb, yb } = finMorphGeometry(thick, thin, morph);
  const bar = `M${barStart} ${thin}
          H${barEnd + thick}
          L${barEnd + thick * (1 - fb)} ${yb}
          H${barStart + thick * fb}
          Z`;
  const fin1 = `M${barEnd + thick * 1.5 - thick * f1} ${y1}
          L${barEnd + thick * 1.5} ${thin}
          H${barEnd + thick * 3}
          L${barEnd + thick * 3 - thick * f1} ${y1}
          Z`;
  const fin2 = `M${barEnd + thick * 3.5 - thick * f2} ${y2}
          L${barEnd + thick * 3.5} ${thin}
          H${barEnd + thick * 5}
          L${barEnd + thick * 5 - thick * f2} ${y2}
          Z`;
  return [bar, fin1, fin2];
};

// Dome-head bolts pinning the frame's thick plates: two on the top bar, one
// near each end of the left/right rails' wide sections, two on the bottom
// tab. Returns plain circles for the caller to fill with the shared bolt
// gradient — no filters, so the per-frame cost is a handful of circle
// nodes. During the page-switch pulse the heads bracket the plate wave:
// all pop out first and pop back last (boltPlop), staggered right-to-left
// by the same rank that orders the plates, so the wave reading survives
// while no head ever animates over empty background. Rails too short for
// two heads drop theirs so small frames stay clean.
export const mainFrameBolts = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
  morph = 0,
): { cx: number; cy: number; r: number }[] => {
  const barStart = thick + thin + corner + w / 10;
  const barEnd = w - w / 3 - 60;
  const railW = thick + thin;
  const tabStart = thick * 2 + corner - thin + w / 4;
  const tabEnd = w - (thick * 3.5 + corner - thin * 3);
  const barR = (thick - thin) * 0.32;
  // The bar is flush under the ring's thin top strip, so the visible band
  // runs y = 0..thick; center the heads on that, not on the bar subpath.
  const barCy = thick * 0.5;
  const bolts = [
    // Top bar body, right head popping first (rank via plate order 6).
    { cx: barEnd - thick * 1.5, cy: barCy, r: barR, order: 5.6 },
    // The bar's left end anchors a triple like the band's, at the bar
    // heads' larger pitch. Ranks step 6.3 -> 6.5 with increasing x (the
    // same return ripple as the band's left trio); all three still pop in
    // only after the bar has fully regrown at 0.8875 (rank >= 0.7875).
    ...[0, 1, 2].map((i) => ({
      cx: barStart + thick * 2 + i * thin * 3.6,
      cy: barCy,
      r: barR,
      order: 6.3 + i * 0.1,
    })),
    // Title band's long blade (mainFrameTitle's geometry: left edge at
    // thick + thin*2 + corner/3, cuts ending at corner*3.25 - thick*4),
    // half the bar heads' size to match the blade's slighter 3*thin build.
    // Ranks keep the old wave-order slots (2.7, and 3.1-3.3 below): the
    // bracket clears the blade's wipe with margin — heads gone by ~0.11,
    // the blade holding full width until 0.22 and whole again at 0.64,
    // heads reseating from 0.877.
    // The right end carries a lone head just past the tally — trimmed
    // from the original triple so the tally reads unencumbered.
    {
      cx: corner * 3.25 - thick * 4 - thick * 1.5 + thin * 3.6,
      cy: corner - thin * 1.5,
      r: barR / 2,
      order: 2.7,
    },
    // The left end anchors a tight triple instead of a lone head — the
    // blade's counterweight to the tally etched at its right end. Ranks
    // step 3.1 -> 3.3 so the trio pops out and returns as a tiny ripple
    // inside the same bracket slots.
    ...[0, 1, 2].map((i) => ({
      cx: thick + thin * 2 + corner / 3 + thick * 1.5 + i * thin * 1.8,
      cy: corner - thin * 1.5,
      r: barR / 2,
      order: 3.1 + i * 0.1,
    })),
    // Bottom tab, continuing toward the bottom fins' left-to-right roll.
    {
      cx: tabStart + thick * 3,
      cy: h - thick * 1.25,
      r: thick * 0.42,
      order: 7.4,
    },
    { cx: tabEnd - thick * 2, cy: h - thick * 1.25, r: thick * 0.42, order: 8 },
  ];
  // Rails: the wide sections run from below the outward jog down to the jog
  // back in. The right rail sits under the early (right) end of the wave,
  // the left rail bridges the bar into the bottom roll.
  const railL: [number, number] = [
    thin + corner + h * 0.2 + thick,
    h - thick * 2.5 - corner - h * 0.1,
  ];
  const railR: [number, number] = [
    thin + corner + h * 0.1 + thick,
    h - thick * 2.5 - corner - h * 0.2,
  ];
  if (railR[1] - railR[0] > thick * 8) {
    bolts.push(
      {
        cx: w - railW / 2,
        cy: railR[0] + thick * 1.6,
        r: railW * 0.26,
        order: 1.5,
      },
      {
        cx: w - railW / 2,
        cy: railR[1] - thick * 1.6,
        r: railW * 0.26,
        order: 2.5,
      },
    );
  }
  if (railL[1] - railL[0] > thick * 8) {
    bolts.push(
      {
        cx: railW / 2,
        cy: railL[0] + thick * 1.6,
        r: railW * 0.26,
        order: 6.8,
      },
      {
        cx: railW / 2,
        cy: railL[1] - thick * 1.6,
        r: railW * 0.26,
        order: 7.2,
      },
    );
  }
  // Uniform head scale: every base radius above is halved together, so the
  // bar : band : tab : rail size ratios (and the 1.5x shadow halo derived
  // from r at the callsite) are preserved while the heads read half size.
  const BOLT_SCALE = 0.5;
  return bolts.map(({ cx, cy, r, order }) => ({
    cx,
    cy,
    r: r * BOLT_SCALE * boltPlop(morph, order / (WAVE_PIECES - 1)),
  }));
};

// A single slash pip: the same "/" parallelogram as every fin here,
// hairline-wide, with horizontal end caps to match the horizontal top
// line it sits under. Used by mainFramePips.
const slashPip = (x: number, y: number, wd: number, hgt: number): string =>
  `M${x} ${y}
          H${x + wd}
          L${x + wd + hgt} ${y - hgt}
          H${x + hgt}
          Z`;

// Vent groups: three tiny etched grooves, echoing the frame's slash rhythm
// at whisper scale. Deliberately confined to metal that never morphs (the
// rail wide sections) so a groove can never hover over
// background during the page-switch pulse — they are engravings, not
// moving parts. Callers paint them dark at low opacity for an inset look,
// each over a light same-shape copy nudged a hair down-right — the
// groove's chisel lip catching the frame's upper-left light.
// Rails reuse the bolts' length guard so short frames drop them together.
export const mainFrameVents = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
): string[] => {
  const wd = thin * 0.7;
  const hgt = thick * 0.35;
  const step = hgt + thin * 1.5;
  // Vertical-cap slit: these grooves live on vertical rails, so their
  // short end caps run parallel to the rail's edges (the transposed cousin
  // of the pips' horizontal-cap slashPip), long sides on the same "/"
  // slant rising bottom-left to top-right.
  const slit = (x: number, y: number): string =>
    `M${x} ${y}
          V${y + wd}
          L${x + hgt} ${y + wd - hgt}
          V${y - hgt}
          Z`;
  const group = (x: number, y: number): string[] =>
    [0, 1, 2].map((k) => slit(x, y + k * step));
  const vents: string[] = [];
  const railW = thick + thin;
  // Rails: stacked below each wide section's upper bolt.
  const railL: [number, number] = [
    thin + corner + h * 0.2 + thick,
    h - thick * 2.5 - corner - h * 0.1,
  ];
  const railR: [number, number] = [
    thin + corner + h * 0.1 + thick,
    h - thick * 2.5 - corner - h * 0.2,
  ];
  const rowW = hgt;
  if (railR[1] - railR[0] > thick * 8) {
    vents.push(...group(w - railW / 2 - rowW / 2, railR[0] + thick * 3.4));
  }
  if (railL[1] - railL[0] > thick * 8) {
    vents.push(...group(railW / 2 - rowW / 2, railL[0] + thick * 3.4));
  }
  return vents;
};

// Extra whisper-scale engravings varying the etched vocabulary beyond the
// vents' repeated slit so the plates read machined rather than stamped —
// sized to what each plate can carry:
// - bottom tab: a tally of three hairline slashes before its right bolt
//   — the tally a quiet cousin of the page pips (fixed count, so it can
//   never be misread as an indicator);
// - top bar: no etching of its own — its right end carries the page pip
//   row (mainFramePips), and it already wears the gold dip, the
//   structural cuts and both bolt anchors;
// - title band blade: a single tally at reduced scale before its right
//   bolt, sized to the blade's 3 * thin height — the blade's left end is
//   answered by its bolt triple instead of more etching;
// - rails: two nested chevrons near each wide section's lower end,
//   pointing down the run toward the tab.
// Paint contract matches the vents: callers draw everything dark at low
// opacity for the inset look, each over a light same-shape copy nudged a
// hair down-right (the groove's chisel lip catching the frame's
// upper-left light), and dim the group inside the pulse bracket
// (mainFrameMarkFade). Rails and tab never morph. The bar and blade do,
// but marks are visible only outside the fade bracket (phase <= 0.14 or
// >= 0.86): the bar only loses its bottom edge and is >= 84% regrown at
// 0.86 (tally sits in the band's upper 0.72 * thick), and the blade's
// wipe nests tighter still: it holds full width until 0.22 (the instant
// the fade bottoms out) and is whole again at 0.64, before the fade
// lifts at 0.78 — every mark is metal-backed while visible.
export const mainFrameEtchings = (
  w: number,
  h: number,
  corner: number,
  thick: number,
  thin: number,
): string[] => {
  const marks: string[] = [];
  const push = (d: string): void => {
    marks.push(d);
  };
  // Shared shape kit; every motif hangs off its plate's bolt center line.
  // k scales a motif down for slighter plates (the title band blade).
  const tally = (xEnd: number, cy: number, k = 1): void => {
    const wd = thin * 1.2 * k;
    const hgt = thin * 2.2 * k;
    const step = thin * 3.4 * k;
    for (let i = 0; i < 3; i++) {
      push(slashPip(xEnd - (3 - i) * step, cy + hgt / 2, wd, hgt));
    }
  };
  // Bottom tab, reading bolt -> clean run -> tally -> bolt.
  const tabStart = thick * 2 + corner - thin + w / 4;
  const tabEnd = w - (thick * 3.5 + corner - thin * 3);
  const tabCy = h - thick * 1.25;
  if (tabEnd - tabStart > thick * 12) {
    tally(tabEnd - thick * 3.5, tabCy);
  }
  // Title band blade: one tally at blade scale, short of the right bolt,
  // on the blade's mid-line like the heads. The left end carries the bolt
  // triple (mainFrameBolts), so the blade reads bolts -> clean run ->
  // tally -> bolt without stacking motifs.
  const bandLeft = thick + thin * 2 + corner / 3;
  const bandRight = corner * 3.25 - thick * 4;
  if (bandRight - bandLeft > thick * 10) {
    tally(bandRight - thick * 2.5, corner - thin * 1.5, 0.6);
  }
  // Rails: two nested chevrons near each wide section's lower end,
  // pointing down the run toward the tab.
  const railW = thick + thin;
  const railL: [number, number] = [
    thin + corner + h * 0.2 + thick,
    h - thick * 2.5 - corner - h * 0.1,
  ];
  const railR: [number, number] = [
    thin + corner + h * 0.1 + thick,
    h - thick * 2.5 - corner - h * 0.2,
  ];
  const chevrons = (xc: number, [from, to]: [number, number]): void => {
    if (to - from <= thick * 12) return;
    const leg = thick * 0.36;
    const br = thin * 0.6;
    const gap = thin * 2.2;
    // One downward chevron band: lower boundary vees through (xc, y),
    // upper boundary is the same vee lifted by the hairline breadth.
    const chevron = (y: number): void => {
      push(
        `M${xc - leg} ${y - leg - br}
          L${xc} ${y - br}
          L${xc + leg} ${y - leg - br}
          L${xc + leg} ${y - leg}
          L${xc} ${y}
          L${xc - leg} ${y - leg}
          Z`,
      );
    };
    // Anchor the vee tip 1.45 * thick above the lower bolt's center
    // (to - thick * 1.6) — the same clearance the vents keep below the
    // upper bolt (group top at from + thick * 3.05), so both rail ends
    // read bolt -> equal gap -> engraving.
    const base = to - thick * 3.05;
    chevron(base - leg - br - gap);
    chevron(base);
  };
  chevrons(w - railW / 2, railR);
  chevrons(railW / 2, railL);
  return marks;
};

// Page pips: a right-aligned row of slash pips ON the top bar, ending
// 1.5 * thick short of its right bolt (the same clearance rhythm as the
// tab's tally), one per tab, left to right. Pure geometry — the caller
// decides which pip is the live page and warms only that one to gold,
// painting the rest as etched marks like the neighbouring engravings, so
// the row doubles as a quiet page indicator with no moving parts. Sits in
// the bar band's upper 0.72 * thick, inside the same morph-safety
// envelope the bar engravings documented above.
export const mainFramePips = (
  w: number,
  thick: number,
  thin: number,
  count: number,
): string[] => {
  const wd = thin * 1.2;
  const hgt = thin * 2.2;
  const step = thin * 3.4;
  const xEnd = w - w / 3 - 60 - thick * 3;
  const y = thick * 0.5 + hgt / 2;
  return Array.from({ length: count }, (_, i) =>
    slashPip(xEnd - (count - i) * step, y, wd, hgt),
  );
};

export const subFrame = `M16.881 26.0007L16.946 17.4539L8.60605 17.4421L8.58239 11.6023L190.617 11.5934L197.541 18.6804L197.553 42.3527L16.6681 42.3467L8.62372 34.0865L8.58827 26.0007H16.881ZM2.51504 36.2883L2.45894 26.0037L6.14423 26.0214L6.18267 35.0825L15.6338 44.7908L200 44.7997L199.988 17.6844L191.648 9.1494H183.122L174.758 0.670507L141.744 0.682337L133.319 9.15234H129.299L137.642 0.735501H133.573L125.23 9.15234H121.222L129.565 0.735501H125.496L117.153 9.15234H113.151L121.494 0.735501H117.425L109.082 9.15234L6.12645 9.15823L6.17078 19.8861L14.4812 19.895L14.4546 23.5537H6.13234V23.5744L0 23.5478L0.0768851 37.2577L12.847 50.9527L99.9971 51L100 48.553L13.9109 48.5086L2.51504 36.2883Z`;
